import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const InfiniteCarousel = () => {
    const containerRef = useRef(null);
    const [maxNodes, setMaxNodes] = useState(0);

    const appendNodes = (nodesToAdd) => {
        const appendCount = nodesToAdd;
        for (let i = 0; i < appendCount; i++) {
            const clone1 = document.querySelector(".logos-slide1")?.cloneNode(true);
            const clone2 = document.querySelector(".logos-slide2")?.cloneNode(true);
            const clone3 = document.querySelector(".logos-slide3")?.cloneNode(true);
            const clone4 = document.querySelector(".logos-slide4")?.cloneNode(true);
            const clone5 = document.querySelector(".logos-slide5")?.cloneNode(true);
            const clone6 = document.querySelector(".logos-slide6")?.cloneNode(true);


            if (clone1 || clone2 || clone3 || clone4 || clone5 || clone6) {
                document.querySelector(".logos1").appendChild(clone1);
                document.querySelector(".logos2").appendChild(clone2);
                document.querySelector(".logos3").appendChild(clone3);
                document.querySelector(".logos4").appendChild(clone4);
                document.querySelector(".logos5").appendChild(clone5);
                document.querySelector(".logos6").appendChild(clone6);

                clone1.classList.add("js-appended-slide");
                clone2.classList.add("js-appended-slide");
                clone3.classList.add("js-appended-slide");
                clone4.classList.add("js-appended-slide");
                clone5.classList.add("js-appended-slide");
                clone6.classList.add("js-appended-slide");

            }
            else{
                console.log("failed to clone nodes");
            }
            }
        }


    const removeNodes = (nodesToRemove) => {
        while (nodesToRemove > 0) {
            const logos1 = document.querySelector(".logos1");
            const logos2 = document.querySelector(".logos2");
            const logos3 = document.querySelector(".logos3");
            const logos4 = document.querySelector(".logos4");
            const logos5 = document.querySelector(".logos5");
            const logos6 = document.querySelector(".logos6");

            const lastLogosSlide1=logos1.querySelector(".logos-slide1:last-child");
            const lastLogosSlide2=logos2.querySelector(".logos-slide2:last-child");
            const lastLogosSlide3=logos3.querySelector(".logos-slide3:last-child");
            const lastLogosSlide4=logos4.querySelector(".logos-slide4:last-child");
            const lastLogosSlide5=logos5.querySelector(".logos-slide5:last-child");
            const lastLogosSlide6=logos6.querySelector(".logos-slide6:last-child");

            if (lastLogosSlide1) {
                logos1.removeChild(lastLogosSlide1);
            }
            else{
                console.log("No .logos-slide1 to remove");
            }

            if (lastLogosSlide2) {
                logos2.removeChild(lastLogosSlide2);
            }
            else{
                console.log("No .logos-slide2 to remove");
            }

            if (lastLogosSlide3) {
                logos3.removeChild(lastLogosSlide3);
            }
            else{
                console.log("No .logos-slide3 to remove");
            }

            if (lastLogosSlide4) {
                logos4.removeChild(lastLogosSlide4);
            }
            else{
                console.log("No .logos-slide4 to remove");
            }

            if (lastLogosSlide5) {
                logos5.removeChild(lastLogosSlide5);
            }
            else{
                console.log("No .logos-slide5 to remove");
            }

            if (lastLogosSlide6) {
                logos6.removeChild(lastLogosSlide6);
            }
            else{
                console.log("No .logos-slide6 to remove");
            }

            nodesToRemove--;
        }
    };
    
    

    useEffect(() => {
        const sizeOnLoad = () => {
            const screenwidth = window.innerWidth;
            let maxNodes = 0;
            if (screenwidth >= 2560) {
                maxNodes = 6;
            } else if (screenwidth >= 1440) {
                maxNodes = 4;
            } else {
                maxNodes = 3;
            }

            appendNodes(maxNodes);
            setMaxNodes(maxNodes);
        };

        sizeOnLoad();

        // Attach resize event listener
        const handleResize=()=>{
            const screenwidth = window.innerWidth;
            let newMaxNodes = 0;
            if (screenwidth >= 2560) {
                newMaxNodes = 6;
            } else if (screenwidth >= 1440) {
                newMaxNodes = 4;
            } else {
                newMaxNodes = 3;
            }
            setMaxNodes(prevMaxNodes => {
                if (newMaxNodes > prevMaxNodes) {
                    const nodesToAdd = newMaxNodes - prevMaxNodes;
                    appendNodes(nodesToAdd);
                } else if (newMaxNodes < prevMaxNodes) {

                    const nodesToRemove = prevMaxNodes - newMaxNodes;
                    removeNodes(nodesToRemove);
                }
                return newMaxNodes;
            });
            

            setMaxNodes(newMaxNodes)
        }
        window.addEventListener('resize', handleResize);
    }, []);


        return(
                <div className="newbody">
                    <div ref={containerRef}>
                    <div className="logos1 logo">
                        <div className="logos-slide1">
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-2.webp" srcSet="/img/infinite-carousel/1-row/2xArtboard-2.webp 2x" alt="02" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-3.webp" srcSet="/img/infinite-carousel/1-row/Artboard-32x.webp 2x" alt="03" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-4.webp" srcSet="/img/infinite-carousel/1-row/Artboard-42x.webp 2x" alt="04" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-5.webp" srcSet="/img/infinite-carousel/1-row/Artboard-52x.webp 2x" alt="05" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-6.webp" srcSet="/img/infinite-carousel/1-row/Artboard-62x.webp 2x" alt="06" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-7.webp" srcSet="/img/infinite-carousel/1-row/2xArtboard-7.webp 2x" alt="07" />
                            <img className="grid__img1" src="/img/infinite-carousel/1-row/Artboard-1.webp" srcSet="/img/infinite-carousel/1-row/Artboard-12x.webp 2x" alt="08" />
                        </div>
                    </div>
                
                    <div className="logos2 logo">
                        <div className="logos-slide2">
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/9.webp" srcSet="/img/infinite-carousel/2-row/2x9.webp" alt="01" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Behind-the-Scenes-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xBehind-the-Scenes-Templates.webp 2x" alt="02" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Branded-Quote-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xBranded-Quote-Templates.webp 2x" alt="03" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Event-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xEvent-Templates.webp 2x" alt="04" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Poll_Question-Templates.webp" srcSet="/img/infinite-carousel/2-row/2x_Poll_Question-Templates.webp 2x" alt="05" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Product-Showcase-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xProduct-Showcase-Templates.webp 2x" alt="06" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Tips_Advice-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xTestimonial-Templates.webp 2x" alt="08" />
                            <img className="grid__img2" src="/img/infinite-carousel/2-row/Testimonial-Templates.webp" srcSet="/img/infinite-carousel/2-row/2xTips_Advice-Templates.webp 2x" alt="07" />
                        </div>
                    </div> 
                
                    <div className="logos3 logo">
                        <div className="logos-slide3">
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/1.webp" srcSet="/img/infinite-carousel/3-row/1@2x.webp 2x" alt="01"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/2.webp" srcSet="/img/infinite-carousel/3-row/2@2x.webp 2x" alt="02"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/3.webp" srcSet="/img/infinite-carousel/3-row/3@2x.webp 2x" alt="03"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/4.webp" srcSet="/img/infinite-carousel/3-row/4@2x.webp 2x" alt="04"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/5.webp" srcSet="/img/infinite-carousel/3-row/5@2x.webp 2x" alt="05"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/6.webp" srcSet="/img/infinite-carousel/3-row/6@2x.webp 2x" alt="06"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/7.webp" srcSet="/img/infinite-carousel/3-row/7@2x.webp 2x" alt="07"/>
                            <img className="grid__img3" src="/img/infinite-carousel/3-row/1.webp" srcSet="/img/infinite-carousel/3-row/1@2x.webp 2x" alt="01"/>
                        </div>
                    </div> 

                    <div className="logos4 logo">
                        <div className="logos-slide4">
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-1.webp" srcSet="/img/infinite-carousel/4-row/Artboard@2x.webp 2x" alt="01" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-2.webp" srcSet="/img/infinite-carousel/4-row/Artboard-2-transformed@2x.webp 2x" alt="02" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-3.webp" srcSet="/img/infinite-carousel/4-row/Artboard-3@2x.webp 2x" alt="03" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-4.webp" srcSet="/img/infinite-carousel/4-row/Artboard-4@2x.webp 2x" alt="04" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-5.webp" srcSet="/img/infinite-carousel/4-row/Artboard-5_upscaled@2x.webp 2x" alt="05" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-6.webp" srcSet="/img/infinite-carousel/4-row/Artboard-6_upscaled@2x.webp 2x" alt="06" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-2.webp" srcSet="/img/infinite-carousel/4-row/Artboard-2-transformed@2x.webp 2x" alt="01" />
                            <img className="grid__img4" src="/img/infinite-carousel/4-row/Artboard-3.webp" srcSet="/img/infinite-carousel/4-row/Artboard-3@2x.webp 2x" alt="02" />
                        </div>
                    </div>

                    <div className="logos5 logo">
                        <div className="logos-slide5">
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/announcement.webp" srcSet="/img/infinite-carousel/5-row/announcement@2x.webp 2x" alt="01" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/Festival.webp" srcSet="/img/infinite-carousel/5-row/Festival@2x.webp 2x" alt="02" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/Poll-question.webp" srcSet="/img/infinite-carousel/5-row/Poll-question@2x.webp 2x" alt="03" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/Quote.webp" srcSet="/img/infinite-carousel/5-row/Quote@2x.webp 2x" alt="04" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/showcase.webp" srcSet="/img/infinite-carousel/5-row/showcase@2x.webp 2x" alt="05" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/Testimonial.webp" srcSet="/img/infinite-carousel/5-row/Testimonial@2x.webp 2x" alt="06" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/tips.webp" srcSet="/img/infinite-carousel/5-row/tips@2x.webp 2x" alt="07" />
                            <img className="grid__img5" src="/img/infinite-carousel/5-row/Quote.webp" srcSet="/img/infinite-carousel/5-row/Quote@2x.webp 2x" alt="08" />
                        </div>
                    </div>

                    <div className="logos6 logo">
                        <div className="logos-slide6">
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-1.webp" srcset="/img/infinite-carousel/6-row/Artboard-1@2x.webp 2x" alt="01" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-2.webp" srcSet="/img/infinite-carousel/6-row/Artboard-2@2x.webp 2x" alt="02" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-3.webp" srcSet="/img/infinite-carousel/6-row/Artboard-3@2x.webp 2x" alt="03" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-4.webp" srcSet="/img/infinite-carousel/6-row/Artboard-4@2x.webp 2x" alt="04" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-5.webp" srcSet="/img/infinite-carousel/6-row/Artboard-5@2x.webp 2x" alt="05" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-6.webp" srcSet="/img/infinite-carousel/6-row/Artboard-6@2x.webp 2x" alt="06" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-7.webp" srcSet="/img/infinite-carousel/6-row/Artboard-7@2x.webp 2x" alt="07" />
                            <img className="grid__img6" src="/img/infinite-carousel/6-row/Artboard-1.webp" srcSet="/img/infinite-carousel/6-row/Artboard-1@2x.webp 2x" alt="08" />
                        </div>
                    </div>
                    </div>
                </div>
        )  
        }


    export default InfiniteCarousel;